module.exports = __webpack_public_path__ + "img/no-user.af6d3cf8.svg";